import React from "react";
import TagsDeCategorias from "../../TagsDeCategorias";
import PropTypes from "prop-types";

import { Card, Info } from "./styles";
import { formataDataUtcToDDMMYYYY } from "../../../../utils/functions/format";

function DestaqueSecundario(props) {
  const dataFormatada = formataDataUtcToDDMMYYYY(props.data);
  return (
    <Card to={props.to}>
      <img src={props.img} alt="Imagem da noticia mais recente" />
      <TagsDeCategorias categorias={props.categorias} />
      <Info>
        <h1>{props.titulo}</h1>
        <p>{dataFormatada}</p>
      </Info>

      <p>{props.previa}</p>
    </Card>
  );
}

DestaqueSecundario.propTypes = {
  img: PropTypes.string,
  categorias: PropTypes.array,
  titulo: PropTypes.string,
  previa: PropTypes.string,
  data: PropTypes.string,
  to: PropTypes.string,
};

export default DestaqueSecundario;
